// extracted by mini-css-extract-plugin
export var banner = "_dr-0";
export var closeButton = "_dr-2";
export var greenCheckmark = "_dr-3";
export var hereLink = "_dr-4";
export var titleIcon = "_dr-1";